import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { prettyLocalDate } from '../../../lib/time';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '0.5rem 0',
    width: '100%',
    borderBottom: `1px solid ${theme.palette.common.silver}`,
    '&:hover': {
      backgroundColor: theme.palette.common.paleGrey,
    },
  },
  container: {
    padding: 0,
  },
  cell: {
    padding: '0.2rem 0.3rem 0.2rem 0.4rem',
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
  },
  mainText: {
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: 400,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  text: {
    fontSize: '0.8rem',
    '&:first-letter': {
      textTransform: 'capitalize',
    },
  },
  chips: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },
  chip: {
    borderRadius: '4px',
    borderWidth: '3px',
    borderColor: theme.palette.secondary.main,
    marginRight: '0.5rem',
  },
}));

const RequestItem = ({requestId, status, createdAt, updatedAt, detail}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid container spacing={0} className={classes.container}>
        <Grid item lg={2} className={classes.cell}>
          <Typography variant="body2" className={classes.mainText}>{requestId}</Typography>
        </Grid>
        <Grid item lg={4} className={classes.cell}>
          <div className={classes.chips}>
            {detail.services.map(s => (<Chip key={s.name} label={s.name} variant="outlined" className={classes.chip} />))}
          </div>
        </Grid>
        <Grid item lg={2} className={classes.cell}>
          <Typography variant="body2" className={classes.text}>{status}</Typography>
        </Grid>
        <Grid item lg={2} className={classes.cell}>
          <Typography variant="body2" className={classes.text}>{prettyLocalDate(createdAt)}</Typography>
        </Grid>
        <Grid item lg={2} className={classes.cell}>
          <Typography variant="body2" className={classes.text}>{prettyLocalDate(updatedAt)}</Typography>
        </Grid>
      </Grid>
    </div>
  );
};

RequestItem.propTypes = {
  requestId: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  detail: PropTypes.object.isRequired,
};

export default RequestItem;
